import { atom } from 'jotai';
import { configureAtomDevtools } from '../utils/tracking';

// A leaf module on purpose: both the notifications store and the errors store
// read these prefs, and importing them from `notifications/atoms` created a
// cycle (notifications → errors → notifications) that left an atom undefined at
// module-init and silently broke muting at runtime.
export type NotificationKind = 'info' | 'success';

/** A notification the CLIENT raises. `warning` has no wire spelling — the
 *  backend never sends one — so it is not mutable and never round-trips
 *  through `setPrefs` (sdk ADR-014's user-visible half). */
export type NotificationEntryKind = NotificationKind | 'warning';

/** Display-time mute prefs (events ADR-006). A muted kind/origin is still DELIVERED and
 *  stored — this only suppresses the nav-badge count + toasts. */
export interface NotificationMutePrefs {
  mutedKinds: NotificationKind[];
  mutedOrigins: string[];
}

export const notificationMutePrefsAtom = configureAtomDevtools(
  atom<NotificationMutePrefs>({ mutedKinds: [], mutedOrigins: [] }),
  'notifications/mutePrefs',
);
